// extracted by mini-css-extract-plugin
export default {"footerCancelButton":"q4C0u","iconButton":"Sin4y","iconSuccess":"wpyJT","success-icon":"D3Eh1","container":"fv0_O"};